import { Container, Typography, Box, Grid, Button, Paper } from '@mui/material'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import BoltIcon from '@mui/icons-material/Bolt'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'

export default function AboutPage() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 8,
          mb: 6,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="h2" component="h1" fontWeight="bold" gutterBottom>
            Powering Your Future
          </Typography>
          <Typography variant="h5" sx={{ maxWidth: 800, mx: 'auto', opacity: 0.9 }}>
            Starwave Energy is dedicated to providing sustainable, efficient, and affordable solar solutions for homes and businesses.
          </Typography>
        </Container>
        {/* Abstract shapes for background interest */}
        <Box sx={{ position: 'absolute', top: -100, left: -100, width: 300, height: 300, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.1)' }} />
        <Box sx={{ position: 'absolute', bottom: -50, right: -50, width: 200, height: 200, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.1)' }} />
      </Box>

      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1593941707882-a5bba14938c7?q=80&w=800&auto=format&fit=crop"
              alt="Solar panels on a roof"
              sx={{ width: '100%', borderRadius: 4, boxShadow: 6 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="overline" color="primary" fontWeight="bold" letterSpacing={1.5}>
              WHO WE ARE
            </Typography>
            <Typography variant="h3" component="h2" fontWeight="bold" gutterBottom>
              Leading the Solar Revolution
            </Typography>
            <Typography variant="body1" paragraph color="text.secondary" sx={{ fontSize: '1.1rem' }}>
              At Starwave Energy, we believe that clean energy should be accessible to everyone. Founded in 2024, our mission is to reduce reliance on fossil fuels and lower energy costs for our customers through state-of-the-art solar technology.
            </Typography>
            <Typography variant="body1" paragraph color="text.secondary" sx={{ fontSize: '1.1rem' }}>
              We partner with top-tier manufacturers to bring you high-efficiency panels, durable batteries, and smart inverters that stand the test of time.
            </Typography>
            <Button variant="contained" size="large" sx={{ mt: 2 }}>
              Get a Quote
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Stats / Why Choose Us */}
      <Box sx={{ bgcolor: 'grey.50', py: 8 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h3" component="h2" fontWeight="bold" gutterBottom>
              Why Choose Starwave?
            </Typography>
            <Typography variant="h6" color="text.secondary">
              We bring expertise, quality, and reliability to every project.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {[
              { icon: <WbSunnyIcon fontSize="large" />, title: 'Premium Products', desc: 'We only stock Tier-1 solar panels and certified inverters.' },
              { icon: <BoltIcon fontSize="large" />, title: 'Expert Installation', desc: 'Our certified engineers ensure your system is safe and efficient.' },
              { icon: <VerifiedUserIcon fontSize="large" />, title: '5-Year Warranty', desc: 'Comprehensive warranty on maintenance and parts.' }
            ].map((item, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper sx={{ p: 4, height: '100%', textAlign: 'center', borderRadius: 4, transition: '0.3s', '&:hover': { transform: 'translateY(-8px)', boxShadow: 4 } }}>
                  <Box sx={{ display: 'inline-flex', p: 2, borderRadius: '50%', bgcolor: 'primary.light', color: 'primary.main', mb: 2 }}>
                    {item.icon}
                  </Box>
                  <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Ready to Go Solar?
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Join hundreds of satisfied customers who are saving money and the planet.
        </Typography>
        <Button variant="contained" size="large" sx={{ mt: 2, px: 6, py: 1.5, fontSize: '1.2rem' }}>
          Shop Now
        </Button>
      </Container>
    </Box>
  )
}